var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummaryLoading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clfp7nvk9a)",
    fill: "#1847CA"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8 3.5a4.501 4.501 0 0 0 0 9 4.497 4.497 0 0 0 3.865-2.194l.002.003a.75.75 0 0 0 1.34.67A6 6 0 1 1 8 2a.75.75 0 1 0 .001 1.5z",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 2.75A.75.75 0 0 1 8 2a6 6 0 0 1 5.196 9 .75.75 0 0 1-1.298-.75A4.501 4.501 0 0 0 8 3.5a.75.75 0 0 1-.75-.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clfp7nvk9a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h12v12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryLoading);
export default __webpack_public_path__ + "static/media/summary_loading.11b40924e99035eb5ae590667a9ed293.svg";
export { ForwardRef as ReactComponent };